"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const formatFieldDataListItem_1 = require("./formatFieldDataListItem");
const bindDataWithInitialData = (list = [], initialList = []) => {
    const result = [];
    const leftInitialList = [...initialList];
    const toResultObject = (data, initialData) => ({ data, initialData });
    const findById = (id) => (el) => R.path(['id'], el) === id;
    for (const item of list) {
        if (!item || (!item.id && typeof item !== 'string')) {
            result.push(toResultObject(item, null));
            continue;
        }
        const initialDataInx = leftInitialList.findIndex(item.id ? findById(item.id) : R.equals(item));
        let initialData = null;
        if (initialDataInx !== -1) {
            initialData = leftInitialList[initialDataInx];
            leftInitialList.splice(initialDataInx, 1);
        }
        result.push(toResultObject(item, initialData));
    }
    for (const item of leftInitialList) {
        if (!item || (!item.id && typeof item !== 'string')) {
            continue;
        }
        result.push(toResultObject(null, item));
    }
    return result;
};
exports.formatFieldDataList = (type, data, { fieldSchema, schema, initialData }, options) => R.pipe((data) => bindDataWithInitialData(data, initialData), 
// // @ts-ignore
// data => console.log('binded data', data) || data,
R.map(item => formatFieldDataListItem_1.formatFieldDataListItem(type, item.data, {
    fieldSchema,
    schema,
    initialData: item.initialData,
}, options)), R.filter((item) => Boolean(item)), R.groupBy(R.prop('type')), R.mapObjIndexed(R.map(R.prop('data'))))(data);
//# sourceMappingURL=formatFieldDataList.js.map